import React, { Component } from 'react';
import { connect } from 'react-redux';
import { doFeaturedDestinationMapSearch, searchComplete } from '../search/actions';
import AttractionsMapComponent from '../global/attractions-map-component';
import { MAGIC_NUMBER } from '../../constants/magicNumbers';

const mapStateToProps = state => ({
  search: state.Search
});

class DestinationMapComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      center: [38.4351, -78.8698]
    }
  }

  componentDidMount() {
    let { dispatch } = this.props;
    let radius = document.getElementById("radius") ? document.getElementById("radius").value : MAGIC_NUMBER.DEFAULT_FEATURED_LISTING_RADIUS;
    let lat = document.getElementById("lat") ? document.getElementById("lat").value : MAGIC_NUMBER.DEFAULT_FEATURED_LISTING_LATITUDE;
    let long = document.getElementById("long") ? document.getElementById("long").value : MAGIC_NUMBER.DEFAULT_FEATURED_LISTING_LONGITUDE;
    if (radius && lat && long) {
      let data = {
        rad: Number(radius),
        lat: Number(lat),
        long: Number(long)
      }
      dispatch(doFeaturedDestinationMapSearch(data)).then(() => dispatch(searchComplete()));
      this.setState({ center: [Number(lat), Number(long)] })
    }
  }

  render() {
    if (!this.props.search.searchComplete) return ("Loading...")

    return (
      <div className="listing-map-container" id="map">
        <div id="places-results" />
        <AttractionsMapComponent listings={this.props.search.results} center={this.state.center} zoom="15" attractionsRadius={16094} underLocalAttrations />
      </div>
    )
  }
}

export default connect(mapStateToProps)(DestinationMapComponent);
